let data1 = [
  /*委托编号*/
  {
    label: "委托编号", value: '', placeholder: "委托编号", name: "commissionNumber", type: 0, warning: 0, warningMsg: "1", readonly: false,
    blur: ((index) => {
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{
    }),
    changes:((index)=>{
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {}
    ]
  },
  /*参与方总数*/
  {
    label: "参与方总数", value: '', placeholder: "", name: "participantsNum", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{

    }),
    changes:((index)=>{
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value: '1',
        label: '1'
      },
      {
        value: '2',
        label: '2'
      }
    ]
  },
  /*事故形态*/
  {
    label: "事故形态", value: '',placeholder: "", name: "accidentForm", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{

    }),
    changes:((index)=>{
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value: '1',
        label: '人与汽车相撞'
      },
      {
        value: '2',
        label: '非机动车与汽车相撞'
      },
      {
        value: '3',
        label: '机动二/三轮车与汽车相撞'
      },
      {
        value: '4',
        label: '汽车单车事故'
      },
      {
        value: '5',
        label: '汽车撞静止车辆'
      },
      {
        value: '6',
        label: '汽车与汽车正面相撞'
      },
      {
        value: '7',
        label: '汽车与汽车侧门相撞'
      },
      {
        value: '8',
        label: '汽车与汽车尾随相撞'
      },
      {
        value: '9',
        label: '汽车与汽车相对刮撞'
      },
      {
        value: '10',
        label: '汽车与汽车同向刮撞'
      },
      {
        value: '11',
        label: '特殊事故形态'
      }
    ]
  },
  /*事故具体类型*/
  {
    label: "事故具体类型", value: '', placeholder: "事故具体类型", name: "accidentType", type: 0, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    focus:((index)=>{

  }),
    changes:((index)=>{
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    options: [
    {}
  ]
  },
  /*障碍物类型*/
  {
    label: "障碍物类型", value: '', placeholder: "", name: "obstacleType", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    focus:((index)=>{

  }),
    changes:((index)=>{
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    options: [
    {
      value: '1',
      label: '无'
    },
    {
      value: '2',
      label: '中央隔离带'
    },
    {
      value: '3',
      label: '路边树木/路灯杆'
    },
    {
      value: '4',
      label: '路上放置的牌子'
    },
    {
      value: '5',
      label: '路上的施工围栏'
    },
    {
      value: '6',
      label: '路上固定建筑物'
    },
    {
      value: '7',
      label: '路上临时建筑物'
    },
    {
      value: '8',
      label: '动态障碍物'
    },
    {
      value: '999',
      label: '未知'
    },
  ]
  },
  /*天网及其他视频*/
  {
    label: "天网及其他视频", value: '', placeholder: "",name: "otherVideo", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    focus:((index)=>{

  }),
    changes:((index)=>{
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    options: [
    {
      value: '1',
      label: '天网监控视频'
    },
    {
      value: '2',
      label: '其他监控视频'
    },
    {
      value: '3',
      label: '无监控视频'
    }
  ]
  },
  /*事故分类*/
  {
    label: "事故分类", value: '', placeholder: "", name: "classificationOfAccidents", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    focus:((index)=>{

  }),
    changes:((index)=>{
    let data = this.a.data1.total[index];
    if (data.value === '') {
      data.warning = 1;
      data.warningMsg = "必填信息不得为空";
    } else {
      data.warning = 0;
    }
  }),
    options: [
    {
      value: '1',
      label: '轻微事故'
    },
    {
      value: '2',
      label: '一般事故'
    },
    {
      value: '3',
      label: '重大事故'
    },
    {
      value: '4',
      label: '特大事故'
    }
  ]
  },
  /*场景类别*/
  {
    label: "参与方类别", value: '', placeholder: "", name: "typeOfParticipants", type: 1, warning: 0, warningMsg: "", readonly: false,
    blur: ((index) => {
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{

    }),
    changes:((index)=>{
      let data = this.a.data1.total[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value: '1',
        label: '车—人'
      },
      {
        value: '2',
        label: '车—车'
      },
      {
        value: '3',
        label: '车—二轮车'
      }
    ]
  },
  /*路段信息*/
  {label:"*路段信息",value:'',placeholder:"",name:"roadInformation",type:1,warning:0,warningMsg:"",readonly:false,
    blur: ((index) => {
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{
    }),
    changes:((index)=>{
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value: '1',
        label: '三支分叉口'
      },
      {
        value: '2',
        label: '四支分叉口'
      },
      {
        value: '3',
        label: '多支分叉口'
      },
      {
        value: '4',
        label: '环形交叉'
      },
      {
        value: '5',
        label: '闸道口'
      },
      {
        value: '6',
        label: '普通路段'
      },
      {
        value: '7',
        label: '高架路段'
      },
      {
        value: '8',
        label: '变窄路段'
      },
      {
        value: '9',
        label: '窄路'
      },
      {
        value: '10',
        label: '桥梁'
      },
      {
        value: '11',
        label: '隧道'
      },
      {
        value: '12',
        label: '路段进出处'
      },
      {
        value: '13',
        label: '路侧险要路段'
      },
      {
        value: '14',
        label: '其他特殊路段'
      }
    ]
  },
  /*天气*/
  {label:"*天气",value:'',placeholder:"",name:"weather",type:1,warning:0,warningMsg:"",readonly:false,
    blur: ((index) => {
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{
    }),
    changes:((index)=>{
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value: '1',
        label: '晴'
      },
      {
        value: '2',
        label: '阴'
      },
      {
        value: '3',
        label: '雨'
      },
      {
        value: '4',
        label: '雪'
      },
      {
        value: '5',
        label: '雾'
      },
      {
        value: '6',
        label: '大风'
      },
      {
        value: '7',
        label: '沙尘'
      },
      {
        value: '8',
        label: '冰雹'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*事故发生时段*/
  {label:"*事故发生时段",value:'',placeholder:"",name:"periodOfAccident",type:1,warning:0,warningMsg:"",readonly:false,
    blur: ((index) => {
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    focus:((index)=>{
    }),
    changes:((index)=>{
      let data = this.a.data1.env[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value: '1',
        label: '日间'
      },
      {
        value: '2',
        label: '夜间'
      },
      {
        value: '3',
        label: '晨昏'
      }
    ]
  },
  /*照明情况*/
  {label:"照明情况",value:'',placeholder:"",name:"lightingSituation",type:1,warning:0,warningMsg:"",readonly:false,
    blur:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '良好'
      },
      {
        value: '2',
        label: '差，对事故产生一定影响'
      },
      {
        value: '3',
        label: '未知'
      }
    ]
  },
  /*道路行政等级*/
  {label:"道路行政等级",value:'',placeholder:"",name:"administrativeRankOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '公路'
      },
      {
        value: '2',
        label: '城市道路'
      },
      {
        value: '3',
        label: '厂矿道路'
      },
      {
        value: '4',
        label: '林区道路'
      },
      {
        value: '5',
        label: '乡村道路'
      },
      {
        value: '888',
        label: '其他'
      },
      {
        value: '999',
        label: '未知'
      }
    ]
  },
  /*公路等级*/
  {label:"公路等级",value:'',placeholder:"",name:"classOfRoad",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '高速公路'
      },
      {
        value: '2',
        label: '一级公路'
      },
      {
        value: '3',
        label: '二级公路'
      },
      {
        value: '4',
        label: '三级公路'
      },
      {
        value: '5',
        label: '四级公路'
      },
      {
        value: '000',
        label: '不适用'
      },
      {
        value: '999',
        label: '未知'
      }
    ]
  },
  /*城市道路类型*/
  {label:"城市道路类型",value:'',placeholder:"",name:"typeOfCityRoad",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '快速路'
      },
      {
        value: '2',
        label: '主干路'
      },
      {
        value: '3',
        label: '次干路'
      },
      {
        value: '4',
        label: '支路'
      },
      {
        value: '000',
        label: '不适用'
      }
    ]
  },
  /*总体机动车道数（条）*/
  {label:"整体机动车道数（条）",value:'',placeholder:"",name:"totalNumberOfMotorVehicleLanes",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options:[
      {}
    ]
  },
  /*道路的线形*/
  {label:"道路的线形",value:'',placeholder:"",name:"theLinearShapeOfTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '平直'
      },
      {
        value: '2',
        label: '一般弯'
      },
      {
        value: '3',
        label: '一般坡'
      },
      {
        value: '4',
        label: '急弯'
      },
      {
        value: '5',
        label: '陡坡'
      },
      {
        value: '6',
        label: '连续下坡'
      },
      {
        value: '7',
        label: '一般弯坡'
      },
      {
        value: '8',
        label: '急弯陡坡'
      },
      {
        value: '9',
        label: '一般坡急弯'
      },
      {
        value: '10',
        label: '一般弯陡坡'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*沿道路方向的趋势*/
  {label:"沿道路方向的趋势",value:'',placeholder:"",name:"trendsAlongTheRoad",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '平坦的'
      },
      {
        value: '2',
        label: '上升'
      },
      {
        value: '3',
        label: '下降'
      }
    ]
  },
  /*对向车道隔离形式*/
  {label:"对向车道隔离形式",value:'',placeholder:"",name:"isolationFormOfOppositeVehicleLane",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '没有隔离'
      },
      {
        value: '2',
        label: '单虚线'
      },
      {
        value: '3',
        label: '单实线'
      },
      {
        value: '4',
        label: '双实线'
      },
      {
        value: '5',
        label: '中央绿化带'
      },
      {
        value: '6',
        label: '隔离栅栏'
      },
      {
        value: '7',
        label: '单向道'
      },
      {
        value: '8',
        label: '石墩隔离'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*最高允许车速(KM/H)*/
  {label:"最高允许车速(KM/H)",value:'',placeholder:"",name:"maximumAllowedSpeed",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*路面材料*/
  {label:"路面材料",value:'',placeholder:"",name:"typeOfRoadSurface",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '沥青'
      },
      {
        value: '2',
        label: '水泥'
      },
      {
        value: '3',
        label: '沙石'
      },
      {
        value: '4',
        label: '土路'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*道路表面污染*/
  {label:"道路表面污染",value:'',placeholder:"",name:"surfaceFouling",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '否'
      },
      {
        value: '2',
        label: '油'
      },
      {
        value: '3',
        label: '燃料'
      },
      {
        value: '4',
        label: '污垢'
      },
      {
        value: '5',
        label: '石头'
      },
      {
        value: '6',
        label: '掉落的货物'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*路表潮湿度*/
  {label:"路表潮湿度",value:'',placeholder:"",name:"roadSurfaceHumidity",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '干'
      },
      {
        value: '2',
        label: '湿'
      },
      {
        value: '3',
        label: '冰冻'
      },
      {
        value: '4',
        label: '积雪'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*路面状况*/
  {label:"路面状况",value:'',placeholder:"",name:"roadCondition",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '平坦'
      },
      {
        value: '2',
        label: '有凹槽'
      },
      {
        value: '3',
        label: '排水槽'
      },
      {
        value: '4',
        label: '松动的路表'
      },
      {
        value: '5',
        label: '搓衣板状'
      },
      {
        value: '6',
        label: '坑洼'
      },
      {
        value: '7',
        label: '波浪状'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*交通标志是否被遮挡*/
  {label:"交通标志是否被遮挡",value:'',placeholder:"",name:"trafficSignsNotVisible",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '无交通标志'
      },
      {
        value: '2',
        label: '否'
      },
      {
        value: '3',
        label: '是，因为植物'
      },
      {
        value: '4',
        label: '是，因为建筑'
      },
      {
        value: '5',
        label: '是，因为车辆'
      },
      {
        value: '6',
        label: '是，因为天气'
      },
      {
        value: '888',
        label: '是，其他'
      }
    ]
  },
  /*路口信号灯*/
  {label:"路口信号灯",value:'',placeholder:"",name:"intersectionSignalLamp",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '没有'
      },
      {
        value: '2',
        label: '仅有直行信号灯'
      },
      {
        value: '3',
        label: '有直行和转弯信号灯'
      }
    ]
  },
  /*路灯是否开启*/
  {label:"路灯是否开启",value:'',placeholder:"",name:"streetLighting",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '无路灯'
      },
      {
        value: '2',
        label: '有，点亮'
      },
      {
        value: '3',
        label: '有，关闭'
      },
      {
        value: '888',
        label: '其他'
      },
      {
        value: '000',
        label: '不适用'
      }
    ],
  },
  /*影响视线障碍物*/
  {label:"影响视线障碍物",value:'',placeholder:"",name:"viewObstacle",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '无'
      },
      {
        value: '2',
        label: '有，非长期性(如汽车)'
      },
      {
        value: '3',
        label: '有，长期性(如建筑物)'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*交通限速设施*/
  {label:"交通限速设施",value:'',placeholder:"",name:"trafficSpeedLimitingFacilities",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '没有'
      },
      {
        value: '2',
        label: '单一凸起减速带'
      },
      {
        value: '3',
        label: '密集凸起圆点减速带'
      },
      {
        value: '4',
        label: '只有限速标志'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*是否为变宽路段*/
  {label:"*是否为变宽路段",value:'',placeholder:"是否为变宽路段",name:"whetherItIsAWidenedSection",type:1,warning:0,warningMsg:"1",readonly:true,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'是'
      },
      {
        value:'2',
        label:'否'
      },
      {
        value:'3',
        label:'未知'
      },
    ]
  },
  /*是否有为变窄路段*/
  {label:"*是否为变窄路段",value:'',placeholder:"是否有为变窄路段",name:"whetherThereANarrowSection",type:1,warning:0,warningMsg:"1",readonly:true,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'是'
      },
      {
        value:'2',
        label:'否'
      },
      {
        value:'3',
        label:'未知'
      },
    ]
  },
  /*是否有隧道*/
  {label:"*是否有隧道",value:'',placeholder:"是否有隧道",name:"whetherThereATunnel",type:1,warning:0,warningMsg:"1",readonly:true,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'是'
      },
      {
        value:'2',
        label:'否'
      },
      {
        value:'3',
        label:'未知'
      },
    ]
  },
  /*是否为匝道口*/
  {label:"*是否为匝道口",value:'',placeholder:"是否为匝道口",name:"whetherItARamp",type:1,warning:0,warningMsg:"1",readonly:true,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.road[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'是'
      },
      {
        value:'2',
        label:'否'
      },
      {
        value:'3',
        label:'未知'
      },
    ]
  },
  /*车辆类型*/
  {label:"*车辆类型",value:'',placeholder:"",name:"typeOfParticipantCar",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.car[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.car[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'乘用车'
      },
      {
        value:'2',
        label:'客车'
      },
      {
        value:'3',
        label:'货车'
      },
      {
        value:'4',
        label:'半挂牵引车'
      },
      {
        value:'5',
        label:'半挂牵引车及挂车'
      },
      {
        value:'9',
        label:'拖拉机运输机组'
      },
      {
        value:'10',
        label:'轮式专用机械'
      }
    ]
  },
  /*行驶方向*/
  {label:"*行驶方向",value:'',placeholder:"",name:"directionOfDriving",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.car[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.car[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'1',
        label:'直行'
      },
      {
        value:'2',
        label:'左转'
      },
      {
        value:'3',
        label:'右转'
      },
      {
        value:'4',
        label:'向左变道'
      },
      {
        value:'5',
        label:'向右变道'
      },
      {
        value:'6',
        label:'倒车'
      }
    ]
  },
  /*驾驶员性别*/
  {label:"驾驶员性别",value:'',placeholder:"",name:"driverGender",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{
      this.a.data1.car[index].options = this.a.data1.gender;
    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*驾驶员年龄*/
  {label:"驾驶员年龄",value:'',placeholder:"",name:"driverAge",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*驾驶员是否分心*/
  {label:"驾驶员是否分心",value:'',placeholder:"",name:"isTheDriverDistracted",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'2',
        label:'听音乐'
      },
      {
        value:'3',
        label:'导航中'
      },
      {
        value:'4',
        label:'看风景'
      },
      {
        value:'5',
        label:'捡手机'
      },
      {
        value:'888',
        label:'其他'
      },
      {
        value:'999',
        label:'未知'
      }
    ]
  },
  /*驾驶员生理问题*/
  {label:"驾驶员生理问题",value:'',placeholder:"",name:"driverPhysiology",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'疾病/眩晕'
      },
      {
        value:'2',
        label:'昏昏欲睡'
      },
      {
        value:'4',
        label:'其他'
      },
      {
        value:'5',
        label:'未知'
      }
    ]
  },
  /*是否有优先权*/
  {label:"是否有优先权",value:'',placeholder:"",name:"whetherThereAPriority",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'没有'
      },
      {
        value:'2',
        label:'有'
      }
    ]
  },
  /*道路方向*/
  {label:"道路方向",value:'',placeholder:"",name:"roadDirection",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'0',
        label:'停着不动'
      },
      {
        value:'1',
        label:'直线'
      },
      {
        value:'2',
        label:'左转直线'
      },
      {
        value:'3',
        label:'右转曲线'
      },
      {
        value:'4',
        label:'S型曲线'
      }
    ]
  },
  /*行车记录仪数据*/
  {label:"行车记录仪数据",value:'',placeholder:"",name:"vehicleRecordData",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'无'
      },
      {
        value:'2',
        label:'有，未读取到'
      },
      {
        value:'3',
        label:'有，读取到'
      },
      {
        value:'999',
        label:'未知'
      }
    ]
  },
  /*EDR数据*/
  {label:"EDR数据",value:'',placeholder:"",name:"edrData",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'无'
      },
      {
        value:'2',
        label:'有，未读取到'
      },
      {
        value:'3',
        label:'有，读取到'
      },
      {
        value:'999',
        label:'未知'
      }
    ]
  },
  /*是否有视野盲区*/
  {label:"是否有视野盲区",value:'',placeholder:"车外",name:"blindAreaOutsideCar",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'否'
      },
      {
        value:'2',
        label:'隔离带造成'
      },
      {
        value:'3',
        label:'路边树木造成'
      },
      {
        value:'4',
        label:'路上放置的牌子造成'
      },
      {
        value:'5',
        label:'车外人员造成'
      },
      {
        value:'6',
        label:'车外其他车辆造成'
      },
      {
        value:'7',
        label:'路上固定建筑物造成'
      },
      {
        value:'888',
        label:'其他'
      },
      {
        value:'999',
        label:'未知'
      }
    ]
  },
  /*车辆初始速度*/
  {label:"车辆初始速度(km/h)",value:'',placeholder:"",name:"normalDrivingSpeedBeforeVehicleCollision",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*碰撞时速度*/
  {label:"碰撞时速度(km/h)",value:'',placeholder:"",name:"collisionVelocity",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*行人被撞部位*/
  {label:"行人被撞部位",value:'',placeholder:"",name:"pedestrianBeingHit",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '前方'
      },
      {
        value: '2',
        label: '后方'
      },
      {
        value: '3',
        label: '左侧'
      },
      {
        value: '4',
        label: '右侧'
      },
      {
        value: '5',
        label: '碰撞前跌倒，躺在地上'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*年龄*/
  {label:"*年龄",value:'',placeholder:"",name:"agePerson",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {}
    ]
  },
  /*性别*/
  {label:"*性别",value:'',placeholder:"",name:"genderPerson",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value:'1',
        label:'男性'
      },
      {
        value:'2',
        label:'女性'
      },
      {
        value:'3',
        label:'未知'
      }
    ]
  },
  /*身高*/
  {label:"*高度(身高)(cm)",value:'',placeholder:"",name:"vehHight",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {}
    ]
  },
  /*衣着颜色*/
  {label:"参与方颜色(衣着颜色)",value:'',placeholder:"",name:"participantColorPerson",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options:[
      {
        value:'1',
        label:'黄色'
      },
      {
        value:'2',
        label:'橙色'
      },
      {
        value:'3',
        label:'红色'
      },
      {
        value:'4',
        label:'紫色'
      },
      {
        value:'5',
        label:'蓝色'
      },
      {
        value:'6',
        label:'绿色'
      },
      {
        value:'7',
        label:'灰色'
      },
      {
        value:'8',
        label:'棕色'
      },
      {
        value:'9',
        label:'白色'
      },
      {
        value:'10',
        label:'黑色'
      },
      {
        value:'11',
        label:'银色'
      },
      {
        value:'12',
        label:'香槟色'
      },
      {
        value:'888',
        label:'其他'
      },
      {
        value:'000',
        label:'不适用'
      }
    ]
  },
  /*行人被撞地点*/
  {label:"事故发生地点",value:'',placeholder:"",name:"accidentLocation",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '人行道'
      },
      {
        value: '2',
        label: '非机动车道'
      },
      {
        value: '3',
        label: '机动车道'
      },
      {
        value: '4',
        label: '高速/高架'
      },
      {
        value: '888',
        label: '其他'
      }
    ]
  },
  /*行人穿越机动车道位置*/
  {label:"行人穿越机动车道位置",value:'',placeholder:"",name:"pedestrianCrossingTheMotorwayLocation",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '未穿越'
      },
      {
        value: '2',
        label: '有红绿灯处'
      },
      {
        value: '3',
        label: '斑马线处'
      },
      {
        value: '4',
        label: '行人专用通道'
      },
      {
        value: '5',
        label: '无行人过街保护的机动车道路'
      },
      {
        value: '888',
        label: '其他'
      },
      {
        value: '999',
        label: '未知'
      }
    ]
  },
  /*行人行走方向*/
  {label:"行人行走方向",value:'',placeholder:"",name:"pedestrianWalkingDirection",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '从车辆左侧'
      },
      {
        value: '2',
        label: '从车辆右侧'
      },
      {
        value: '3',
        label: '沿车辆运动方向'
      },
      {
        value: '4',
        label: '静止'
      }
    ]
  },
  /*行人运动状态*/
  {label:"行人运动状态",value:'',placeholder:"",name:"pedestrianMovement",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '静止'
      },
      {
        value: '2',
        label: '缓慢步行'
      },
      {
        value: '3',
        label: '快速步行'
      },
      {
        value: '4',
        label: '跑步'
      },
      {
        value: '5',
        label: '前一次碰撞后非正常运动状态'
      },
      {
        value: '888',
        label: '其他'
      },
      {
        value: '999',
        label: '未知'
      }
    ]
  },
  /*碰撞前行人相对于车辆的位置*/
  {label:"碰撞前行人相对于车辆的位置",value:'',placeholder:"",name:"positionOfPedestrianRelativeToVehicleBeforeCollision",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '前方'
      },
      {
        value: '2',
        label: '后方'
      },
      {
        value: '3',
        label: '左侧'
      },
      {
        value: '4',
        label: '右侧'
      }
    ]
  },
  /*黑暗处或夜间衣物可见性*/
  {label:"黑暗处或夜间衣物可见性",value:'',placeholder:"",name:"visibilityInTheDarkOrAtNight",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options:[
      {
        value:'1',
        label:'明亮的'
      },
      {
        value:'2',
        label:'深色的/不可见'
      },
      {
        value:'3',
        label:'反光的'
      },
      {
        value:'4',
        label:'发光的'
      },
      {
        value:'888',
        label:'其他'
      }
    ]
  },
  /*停靠车辆造成行人视野盲区*/
  {label:"停靠车辆造成行人视野盲区:",value:'',placeholder:"",name:"whetherBlindareaOfPedestrianIsCausedByParkedVehicle",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{
      this.a.data1.person[index].options = this.a.data1.yORn;
    }),
    blur:((index)=>{
    }),
    changes:((index)=>{
    }),
    options: [
      {}
    ]
  },
  /*有其他造成行人视线盲区物体*/
  {label:"其他造成行人视线盲区物体:",value:'',placeholder:"",name:"areThereOtherObjectsThatCausePedestrianBlindSpots",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{
      this.a.data1.person[index].options = this.a.data1.yORn;
    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*二轮车种类*/
  {label:"*车辆具体种类",value:'',placeholder:"",name:"typeOfParticipantTwoWheel",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.twoWheel[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.twoWheel[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {
        value:'6',
        label:'机动二轮车/三轮车'
      },
      {
        value:'7',
        label:'非机动二轮车/三轮车'
      },
    ]
  },
  /*二轮车颜色*/
  {label:"参与方颜色",value:'',placeholder:"",name:"participantColorTwoWheel",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'黄色'
      },
      {
        value:'2',
        label:'橙色'
      },
      {
        value:'3',
        label:'红色'
      },
      {
        value:'4',
        label:'紫色'
      },
      {
        value:'5',
        label:'蓝色'
      },
      {
        value:'6',
        label:'绿色'
      },
      {
        value:'7',
        label:'灰色'
      },
      {
        value:'8',
        label:'棕色'
      },
      {
        value:'9',
        label:'白色'
      },
      {
        value:'10',
        label:'黑色'
      },
      {
        value:'11',
        label:'银色'
      },
      {
        value:'12',
        label:'香槟色'
      },
      {
        value:'888',
        label:'其他'
      },
      {
        value:'000',
        label:'不适用'
      }
    ]
  },
  /*二轮车人员年龄*/
  {label:"*年龄",value:'',placeholder:"",name:"ageTwoWheel",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {}
    ]
  },
  /*性别*/
  {label:"*性别",value:'',placeholder:"",name:"genderTwoWheel",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.twoWheel[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.twoWheel[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options: [
      {
        value:'1',
        label:'男性'
      },
      {
        value:'2',
        label:'女性'
      },
      {
        value:'3',
        label:'未知'
      }
    ]
  },
  /*是否为电动车*/
  {label:"是否为电动车",value:'',placeholder:"",name:"electricVehicleOrNot",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{
      this.a.data1.twoWheel[index].options = this.a.data1.yORn;
    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*是否戴头盔*/
  {label:"是否戴头盔",value:'',placeholder:"",name:"wearHelmet",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{
      this.a.data1.twoWheel[index].options = this.a.data1.yORn;
    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*二轮车运动方向*/
  {label:"二轮车运动方向",value:'',placeholder:"",name:"twoWheelerMovementDirection",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value: '1',
        label: '直行'
      },
      {
        value: '2',
        label: '左转'
      },
      {
        value: '3',
        label: '右转'
      },
      {
        value: '4',
        label: '向左变道'
      },
      {
        value: '5',
        label: '向右变道'
      },
      {
        value: '6',
        label: '停车'
      }
    ]
  },
  /*二轮车速度*/
  {label:"二轮车速度(km/h)",value:'',placeholder:"",name:"twoWheelSpeed",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {}
    ]
  },
  /*事故时车灯是否开启*/
  {label:"事故时车灯是否开启",value:'',placeholder:"",name:"whetherTurnSignalOfTwoWheeledVehicleTurned",type:1,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{

    }),
    changes:((index)=>{

    }),
    options: [
      {
        value:'1',
        label:'否'
      },
      {
        value:'2',
        label:'近光灯'
      },
      {
        value:'3',
        label:'远光灯'
      },
      {
        value:'999',
        label:'未知'
      },
      {
        value:'000',
        label:'不适用'
      }
    ]
  },
  /*二轮车乘客数*/
  {label:"*二轮车乘客数",value:'',placeholder:"",name:"numberPassengersOnTwoWheelers",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {}
    ]
  },
  /*与车辆行驶方向的关系*/
  {label:"*与车辆行驶方向的关系",value:'',placeholder:"",name:"relationOfDrivingDirection",type:0,warning:0,warningMsg:"",readonly:false,
    focus:((index)=>{

    }),
    blur:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    changes:((index)=>{
      let data = this.a.data1.person[index];
      if (data.value === '') {
        data.warning = 1;
        data.warningMsg = "必填信息不得为空";
      } else {
        data.warning = 0;
      }
    }),
    options:[
      {}
    ]
  }
];

export default data1;



// WEBPACK FOOTER //
// ./src/assets/javascript/findData.js